<template>
  <nav class="site-nav">
    <div class="nav-inner">
      <!-- مجموعة الأيقونات (الصفحة الرئيسية + التحديث) -->
      <div class="nav-icons">
        <button class="nav-logo" @click="$router.push('/')">
          🏠
        </button>
        <button class="nav-refresh" @click="refreshApp">
          🔄 <span class="refresh-text">تحديث</span>
        </button>
      </div>

      <!-- عنوان التطبيق في الوسط -->
      <h1 class="nav-title">MQBanK+</h1>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  methods: {
    refreshApp() {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(regs => {
          regs.forEach(reg => reg.unregister());
        });
      }
      window.location.reload(true);
    }
  }
}
</script>

<style scoped>
.site-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 4rem;
  background: rgba(0,0,0,0.9);
  backdrop-filter: blur(8px);
  color: #fff;
  z-index: 1000;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 12px rgba(0,0,0,0.5);
}

.nav-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* مجموعة الأيقونات */
.nav-icons {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

/* زر الصفحة الرئيسية */
.nav-logo {
  background: linear-gradient(135deg, #0078d4, #005a9e);
  border: none;
  border-radius: 50%;
  color: #fff;
  font-size: 1.4rem;
  cursor: pointer;
  width: 2.8rem;
  height: 2.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.nav-logo:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(0,0,0,0.35);
}

/* عنوان التطبيق */
.nav-title {
  font-size: 1.3rem;                 /* حجم خط أوضح */
  font-weight: 700;                  /* خط بارز */
  color: #f9f9f9;                    /* لون فاتح */
  margin: 0;                         /* إزالة الهوامش الافتراضية */
  padding: 0 1rem;                   /* هامش داخلي يمنع الالتصاق بالحواف */
  text-shadow: 0 0 8px rgba(0,0,0,0.5); /* ظل أنيق للنص */
  letter-spacing: 0.8px;             /* تباعد بين الحروف */
  white-space: nowrap;               /* منع تقطيع النص */
  overflow: hidden;                  /* منع تجاوز النص */
  text-overflow: ellipsis;           /* إذا النص طويل يظهر ... */
}


/* زر التحديث */
.nav-refresh {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  background: linear-gradient(135deg, #28a745, #218838);
  border: none;
  border-radius: 20px;
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  padding: 0.5rem 1.2rem;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.nav-refresh:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0,0,0,0.35);
}
.refresh-text {
  display: inline-block;
}
</style>
